import { render, staticRenderFns } from "./ResearchProfileEdit.vue?vue&type=template&id=0f7b08d1&scoped=true&"
import script from "./ResearchProfileEdit.vue?vue&type=script&lang=js&"
export * from "./ResearchProfileEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f7b08d1",
  null
  
)

export default component.exports